<template>
    <div>
        <div class="sub-title">废弃原因：</div>
        <el-input
            class="textarea"
            v-model.trim="deprecateReason"
            type="textarea"
            :rows="4"
            :disabled="true"
        />
        <div class="sub-title">废弃明细：</div>
        <el-table :data="tableData" v-loading="loading" border :max-height="300">
            <el-table-column prop="supplierCode" label="供应商编码" minWidth="120px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" minWidth="140px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="assessmentScore" label="考核得分" minWidth="100px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="companyName" label="分公司" minWidth="140px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="centerName" label="经营中心" minWidth="160px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="performanceCode" label="绩效单据编码" minWidth="150px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="assessmentStatus_" label="确认状态" minWidth="100px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="assessmentMonth" label="考核月份" minWidth="120px" show-overflow-tooltip></el-table-column>
        </el-table>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
import { getDeprecateInfo } from '../../../api/warehouseResourceManagement/performanceAssessDetail.js';

export default {
    props: {
        auditId: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            loading: false,
            dict: {},
            tableData: [],
            deprecateReason: null,
        };
    },
    methods: {
        load() {
            this.loading = true;
            getDeprecateInfo(this.auditId).then(res => {
                if (res && +res.code === 0) {
                    this.deprecateReason = res.data.deprecateReason
                    this.tableData = res.data.deprecateDetails.map(item => {
                        item.assessmentStatus_ = this.dict.SRM_WAREHOUSE_PERFORMANCE_STATUS[item.assessmentStatus]
                        return item
                    })
                }
            }).finally(() => { this.loading = false; });
        },
    },
    mounted() {
        dictWithUrl('SRM_WAREHOUSE_PERFORMANCE_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data;
                this.load();
            }
        })
    }
};
</script>
<style lang="less" scoped>
.sub-title {
    font-size: 14px;
    margin-bottom: 5px;
}

.textarea {
    margin-bottom: 10px;
}
</style>